<template>
  <tbody>
    <tr
      v-for="(item, index) in casesFiles"
      :key="index"
    >
      <td class="w-200">
        <div class="file">
          <div class="file-image">
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="15"
                cy="15"
                r="15"
                fill="#FFF0E2"
              />
              <path
                d="M21.5508 12.5891H21.144V10.6265C21.1437 10.614 21.1425 10.6016 21.1404 10.5893C21.141 10.5104 21.1128 10.4341 21.0612 10.3745L17.796 6.64427L17.7936 6.64187C17.774 6.62075 17.7519 6.6022 17.7276 6.58667L17.706 6.57347C17.6853 6.56194 17.6633 6.55269 17.6406 6.54587L17.6226 6.53987C17.5977 6.53366 17.5721 6.53044 17.5464 6.53027H9.5202C9.1536 6.53027 8.856 6.82847 8.856 7.19447V12.5885H8.4492C7.9248 12.5885 7.5 13.0133 7.5 13.5377V18.4745C7.5 18.9983 7.9254 19.4237 8.4492 19.4237H8.856V22.8029C8.856 23.1689 9.1536 23.4671 9.5202 23.4671H20.4798C20.8458 23.4671 21.144 23.1689 21.144 22.8029V19.4237H21.5508C22.0746 19.4237 22.5 18.9989 22.5 18.4745V13.5377C22.5 13.0139 22.0752 12.5891 21.5508 12.5891ZM9.5202 7.19447H17.214V10.5929C17.214 10.7765 17.3628 10.9247 17.5464 10.9247H20.4804V12.5885H9.5202V7.19447ZM14.4894 16.2953C13.683 16.0073 13.1508 15.5609 13.1508 14.8559C13.1508 14.0285 13.8492 13.4027 14.9862 13.4027C15.5406 13.4027 15.936 13.5107 16.224 13.6469L15.9792 14.5247C15.6655 14.3719 15.3208 14.2932 14.9718 14.2949C14.4966 14.2949 14.2662 14.5175 14.2662 14.7623C14.2662 15.0719 14.532 15.2081 15.1656 15.4457C16.0224 15.7625 16.4178 16.2083 16.4178 16.8923C16.4178 17.7059 15.7992 18.3965 14.4678 18.3965C13.9134 18.3965 13.3668 18.2453 13.0932 18.0941L13.3164 17.1947C13.6932 17.387 14.109 17.4905 14.532 17.4971C15.036 17.4971 15.3024 17.2877 15.3024 16.9715C15.3024 16.6691 15.0726 16.4969 14.4894 16.2953ZM8.7738 15.9641C8.7738 14.3159 9.954 13.4021 11.4216 13.4021C11.9904 13.4021 12.4218 13.5167 12.6162 13.6109L12.3858 14.4815C12.0943 14.3591 11.7809 14.2978 11.4648 14.3015C10.6014 14.3015 9.9252 14.8265 9.9252 15.9059C9.9252 16.8701 10.5006 17.4821 11.472 17.4821C11.8104 17.4821 12.1704 17.4179 12.393 17.3237L12.552 18.1871C12.3576 18.2801 11.8968 18.3959 11.3142 18.3959C9.6372 18.3965 8.7738 17.3459 8.7738 15.9641ZM20.4798 22.6241H9.5202V19.4243H20.4798V22.6241ZM19.593 18.3245H18.312L16.758 13.4741H17.9598L18.5496 15.5255C18.7146 16.1081 18.8658 16.6553 18.981 17.2595H19.0026C19.1253 16.6829 19.2716 16.1116 19.4412 15.5471L20.0604 13.4747H21.2256L19.593 18.3245Z"
                fill="#FF792E"
              />
            </svg>
          </div>
          <h3 class="file-title">
            {{ item.filename }}
          </h3>
        </div>
      </td>
      <td>
        <span class="file-size">{{ item.size }}</span>
      </td>
      <td>
        <span class="device-os-type">{{ item.device }}</span>
      </td>
      <td class="w-300">
        <div class="file-owner">
          <span class="owner-name">{{ item.email }}</span>
        </div>
      </td>
      <td>
        <span class="download-date">{{ parseDate(item.date) }}</span>
      </td>
      <td>
        <span
          :class="item.uploadFileStatus.toLowerCase()"
          class="loading-status"
        >{{ item.uploadFileStatus.toLowerCase() }}</span>
      </td>
      <td :id="`download_files_${index}`" :ref="`download_files_${index}`" class="w-200">
        <button
          :id="`download_files_${item.filename}`"
          class="download-file-btn"
          :disabled="!hasPermission(['download_case_file'])"
          @click="downloadItem(item)"
        >
          <span class="btn-text">Download</span>
          <span class="btn-icon">
            <svg
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0)">
                <path
                  d="M9.17501 13.0886C8.1676 11.3079 8.47937 9.07287 9.93541 7.63568C11.3916 6.19848 13.6305 5.91612 15.3979 6.94669C17.1653 7.97726 18.0222 10.065 17.4886 12.04C16.9549 14.0152 15.1633 15.3873 13.1172 15.3875C11.4838 15.3919 9.97577 14.5125 9.17501 13.0886Z"
                  fill="white"
                />
                <path
                  d="M10.9557 6.05705C11.461 6.05636 11.9601 6.16855 12.4164 6.38546C10.9488 6.61581 9.68733 7.5511 9.0405 8.88844C8.39368 10.2258 8.4436 11.7953 9.17419 13.0888H2.61316C2.01211 13.0885 1.43587 12.8486 1.01191 12.4224C0.588091 11.9961 0.351496 11.4185 0.354547 10.8174C0.354408 10.8143 0.354547 10.8114 0.354824 10.8085L0.35843 10.6891C0.360926 9.2633 1.33338 8.04842 2.66864 7.74137V7.74027C2.66905 5.81144 4.01956 4.14625 5.90679 3.74767C7.794 3.34909 9.70258 4.32613 10.4828 6.09006C10.6395 6.06801 10.7975 6.05705 10.9557 6.05705Z"
                  fill="#082655"
                />
                <path
                  d="M13.1169 5.97672C12.901 5.977 12.6853 5.99156 12.4712 6.02013C11.9941 5.80919 11.478 5.70088 10.9562 5.70227C10.8694 5.70227 10.7823 5.70532 10.6955 5.71128C9.93427 4.23401 8.41179 3.30538 6.74979 3.30469C4.39535 3.30469 2.46334 5.14878 2.32229 7.46925C1.69544 7.67311 1.1432 8.05838 0.735328 8.57609C0.263801 9.1777 0.00654113 9.91939 0.00390612 10.6837L0.000855062 10.7902C0.00016164 10.8006 2.29552e-05 10.8092 2.29552e-05 10.8157C-0.00288942 11.5097 0.271428 12.1762 0.762233 12.667C1.25304 13.1578 1.91969 13.4323 2.61367 13.4292H8.9736C9.86312 14.8849 11.4314 15.7355 13.1169 15.7355C15.8095 15.7355 18 13.5486 18 10.8561C18 8.1635 15.8095 5.97672 13.1169 5.97672ZM1.26413 12.1648C0.907019 11.8092 0.707452 11.3254 0.710087 10.8214C0.710087 10.8195 0.710226 10.8195 0.710226 10.8175L0.713832 10.6991C0.713832 10.6957 0.713832 10.693 0.713832 10.6896C0.714664 10.0826 0.91853 9.49335 1.29284 9.01558C1.65869 8.55002 2.17196 8.22258 2.74847 8.0875C2.9099 8.04992 3.02404 7.9061 3.0239 7.74052C3.02431 5.97936 4.2575 4.45896 5.98065 4.09519C7.70367 3.73142 9.44624 4.62344 10.1585 6.23398C10.2229 6.37905 10.3756 6.46392 10.5327 6.44187C10.673 6.42218 10.8145 6.41233 10.9561 6.41233C11.002 6.41233 11.0476 6.41358 11.093 6.41566C9.35401 7.20783 8.23677 8.94139 8.23386 10.8523C8.23178 11.4935 8.35895 12.1284 8.60761 12.7192H2.61367C2.10761 12.7232 1.62124 12.5235 1.26413 12.1648ZM13.1169 15.0328C10.8123 15.0328 8.94392 13.1646 8.94392 10.8598C8.94392 8.55515 10.8123 6.68679 13.1169 6.68679C15.4217 6.68679 17.2901 8.55515 17.2901 10.8598C17.2838 13.162 15.4191 15.0267 13.1169 15.0328Z"
                  fill="#082655"
                />
                <path
                  d="M14.199 10.9333L13.4379 11.6626V9.21929C13.4379 9.02319 13.279 8.86426 13.0829 8.86426C12.8868 8.86426 12.7278 9.02319 12.7278 9.21929V11.6626L11.9843 10.9333C11.9176 10.8678 11.8273 10.8318 11.7339 10.8333C11.6404 10.8348 11.5514 10.8737 11.4867 10.9412C11.3508 11.0827 11.3554 11.3073 11.4967 11.4432L12.8524 12.7562C12.9904 12.8896 13.2093 12.8896 13.3473 12.7562L14.702 11.4432C14.8415 11.3055 14.8432 11.0809 14.7055 10.9412C14.5673 10.8004 14.3416 10.7968 14.199 10.9333Z"
                  fill="#082655"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="18"
                    height="18"
                    fill="white"
                    transform="translate(0 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
        </button>
        <tooltip v-if="!hasPermission(['download_case_file'])" :target-ref="$refs[`download_files_${index}`]" side="bottom">
          <span>To be able to download files - you need to have 'Download case files'</span>
        </tooltip>
      </td>
    </tr>
  </tbody>
</template>

<script>
import '@/assets/css/table.css';
import hasPermission from '../../../utils/permission';
import parseDate from '../../../mixins/parseDate';
import Tooltip from '@/components/common/Tooltip.vue';

export default {
  name: 'CaseFilesItem',
  components: {Tooltip},
  mixins: [parseDate],
  props: {
    casesFiles: [],
  },
  data() {
    return {
      el: {
        isActive: true
      },
    };
  },
  methods: {
    hasPermission,
    download(url, filename) {
      let a = document.createElement('a');
      a.href = url;
      a.setAttribute('download', filename);
      a.setAttribute('target', '_blank');
      a.click();
    },
    downloadItem(item) {
      window.$axiosFiles.get(`/caseFile/${this.$route.params.slug || this.$route.params.case_id}/files/${item.id}`, {
        responseType: 'blob',
      })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', item.filename);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          })
          .catch(error => {
            this.errorMessage = error.response.data.message;
          });
    }
  }
};
</script>

<style scoped>

.file {
  width: 100%;
  max-width: 200px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 33px 0 0;
}

.file-image {
  width: 30px;
  height: 30px;
  overflow: hidden;
}

.file-title {
  margin: 0;
  padding: 0 0 0 9px;
  max-width: calc(100% - 30px);
  font-size: 16px;
  line-height: 16px;
  font-weight: 500;
  color: var(--secondary-black-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-size {
  display: block;
  width: 100%;
  max-width: 100px;
  margin: 0 47px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  text-transform: uppercase;
  text-align: left;
  color: var(--secondary-text-color);
}

.device-os-type {
  display: block;
  width: 100%;
  max-width: 100px;
  margin: 0 47px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  text-transform: uppercase;
  text-align: left;
  color: var(--secondary-text-color);
}

.file-owner {
  width: 100%;
  max-width: 250px;
  display: flex;
  align-items: center;
  margin: 0 40px 0 0;
}

.owner-name {
  padding: 0 0 0 8px;
  font-size: 14px;
  font-weight: 500;
  color: var(--secondary-text-color);
  max-width: calc(100% - 20px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.download-date {
  display: block;
  width: 100%;
  max-width: 100px;
  font-size: 14px;
  font-weight: 400;
  color: var(--secondary-text-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 42px 0 0;
}

.loading-status {
  border: 1px solid transparent;
  padding: 5px 20px;
  text-align: center;
  width: 104px;
  display: block;
  font-size: 12px;
  font-weight: 500;
  border-radius: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.download-file-btn {
  margin: 0 0 0 auto;
  outline: none;
  min-width: 135px;
  padding: 9px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--white-color);
  border: .5px solid var(--case-btn-border-color);
  border-radius: 79px;
  transition: .5s all;
}

.download-file-btn:hover {
  border-color: var(--accent-color);
}

.download-file-btn:hover .btn-text {
  color: var(--accent-color);
}

.btn-text {
  display: block;
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  color: var(--secondary-text-color);
  transition: .5s all;
  max-width: 70px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btn-icon {
  width: 18px;
  height: 18px;
  background-color: #fff;
}

.damaged {
  background-color: var(--damaged-file-color);
  color: var(--white-color);
}

.loading {
  border-color: var(--loading-color);
  color: var(--loading-color);
}

.loaded {
  background-color: var(--loaded-color);
  color: var(--accent-color);
}

.case-files-table.non-border .case-files-item:last-child {
  border-bottom: none;
}

.download-file-btn:disabled {
  border: 1px solid #D7DCE6;
}

.download-file-btn:disabled .btn-text {
  color: #D7DCE6;
}

.download-file-btn:disabled .btn-icon {
  background: transparent;
}

.download-file-btn:disabled .btn-icon svg path:nth-child(1) {
  fill: #fff;
}

.download-file-btn:disabled .btn-icon svg path {
  fill: #D7DCE6;
}

</style>
